import AsyncHelper from "../../../../helpers/AsyncHelper";
import gsap from "../../../../helpers/gsapInstance";
import MainPageFourthScreenCommon from "./MainPageFourthScreenCommon";

export default class MainPageFourthScreenDesktop extends MainPageFourthScreenCommon {
    public readonly $holder: JQuery;

    public DEFAULT_CIRCLE_SHIFT: number = 26;

    constructor($holder: JQuery) {
        super($holder);

        this.$holder = $holder;

        this.setHideScreenAnimation = this.setHideScreenAnimation.bind(this);
        this.setShowScreenAnimation = this.setShowScreenAnimation.bind(this);
        this.setShiftToTopAnimation = this.setShiftToTopAnimation.bind(this);
        this.setOpacityAnimation = this.setOpacityAnimation.bind(this);
        this.setScreensTransitionAnimation = this.setScreensTransitionAnimation.bind(this);
        this.setReverseScreensTransitionAnimation = this.setReverseScreensTransitionAnimation.bind(this);
        this.setMergeCirclesAnimation = this.setMergeCirclesAnimation.bind(this);
        this.setSeparateCirclesAnimation = this.setSeparateCirclesAnimation.bind(this);
    }

    /**
     * Задать анимацию на скрытие экрана
     * @public
     */
    public async setHideScreenAnimation(): Promise<void> {
        this.setMergeCirclesAnimation();
        this.setScreensTransitionAnimation();

        await AsyncHelper.delay(this.ANIMATION_DURATION_IN_SECONDS, true);
    }

    /**
     * Задать анимацию на соединение кругов
     * @private
     */
    private setMergeCirclesAnimation(): void {
        const duration: number = this.ANIMATION_DURATION_IN_SECONDS;

        /* Проходим по $roundsBlockItems и сдвигаем правый и левый круг */
        this.$roundsBlockItems.each((index, item) => {
            const leftCircle = index === 0;
            const rightCircle = index === 2;

            if (leftCircle) {
                gsap.fromTo(item, {
                    transform: `translate(${this.DEFAULT_CIRCLE_SHIFT}px, 0px)`,
                    duration: 0
                }, {
                    transform: `translate(${106}%, 0px)`,
                    duration,
                })
            }

            if (rightCircle) {
                gsap.fromTo(item, {
                    transform: `translate(-${this.DEFAULT_CIRCLE_SHIFT}px, 0px)`,
                    duration: 0
                }, {
                    transform: `translate(-${106}%, 0px)`,
                    duration,
                })
            }
        })
    }

    /**
     * Задать анимацию на переключение 4 на 5 экран
     * @private
     */
    private setScreensTransitionAnimation(): void {
        /* Получаем контейнер с кругами */
        const circlesContainerElement = this.$roundsBlock.get()[0] as HTMLHtmlElement;

        /* Дистанция от контейнера с кругами до верха экрана - header */
        const distanceContainerTopToTop = circlesContainerElement.getBoundingClientRect().top - this.headerHeight;

        /* Дистанция от контейнера до самого низа экрана */
        const distanceContainerBottomToTop = circlesContainerElement.getBoundingClientRect().bottom;
        /* Дистанция от низа контейнера до низа экрана */
        const distanceContainerBottomToBottom = window.innerHeight - distanceContainerBottomToTop;

        /* Суммируем дистанцию от контейнера до верха и до низа экрана и делим на 2, получаем половину дистанции */
        const halfTotalDistance = (distanceContainerTopToTop + distanceContainerBottomToBottom) / 2;
        /* Получаем расстояние, чтобы контейнер с кругами был по центру */
        const translateToTop = distanceContainerTopToTop - halfTotalDistance;

        /*
        *  Задаем анимации для заголовка на сдвиг наверх + opacity в 0
        */
        this.setShiftToTopAnimation(this.$title, -translateToTop, this.ANIMATION_DURATION_IN_SECONDS / 2);
        this.setOpacityAnimation(this.$title, 0, this.QUARTER_ANIMATION_DURATION);

        /* Проходим по $roundsBlockItems и задаем opacity для каждого круга */
        this.$roundsBlockItems.each((index, item) => {
            const $textContent = $(item).find(this.selectors.roundsBlockItemTextContent);
            const leftCircle = index === 0;
            const centerCircle = index === 1;
            const rightCircle = index === 2;

            this.setOpacityAnimation($textContent, 0, this.QUARTER_ANIMATION_DURATION / 2);

            if (leftCircle || rightCircle) {
                this.setOpacityAnimation(item, 0, this.ANIMATION_DURATION_IN_SECONDS);
            }

            if (centerCircle) {
                this.setOpacityAnimation(item, 0.5, this.ANIMATION_DURATION_IN_SECONDS / 2);
            }
        })

        /* Задаем сдвиг для контейнера с кругами наверх, чтобы контейнер был по-центру */
        this.setShiftToTopAnimation(this.$roundsBlock, -translateToTop, this.QUARTER_ANIMATION_DURATION * 3);
    }

    /**
     * Задать анимацию на появление экрана
     * @public
     */
    public async setShowScreenAnimation(): Promise<void> {
        this.setReverseScreensTransitionAnimation();
        this.setSeparateCirclesAnimation();

        await AsyncHelper.delay(this.ANIMATION_DURATION_IN_SECONDS, true);
    }

    /**
     * Задать анимацию на разделение кругов, когда идем с 5 экрана на 4
     * @private
     */
    private setSeparateCirclesAnimation(): void {
        const duration: number = this.ANIMATION_DURATION_IN_SECONDS;

        this.$roundsBlockItems.each((index, item) => {
            const leftCircle = index === 0;
            const rightCircle = index === 2;

            if (leftCircle) {
                gsap.to(item, {
                    transform: `translate(${this.DEFAULT_CIRCLE_SHIFT}px, 0px)`,
                    duration
                })
            }

            if (rightCircle) {
                gsap.to(item, {
                    transform: `translate(-${this.DEFAULT_CIRCLE_SHIFT}px, 0px)`,
                    duration
                })
            }
        })
    }

    /**
     * Задать анимацию на переключение 5 на 4 экран
     * @private
     */
    private setReverseScreensTransitionAnimation(): void {
        /*
        *  Задаем анимации для заголовка на сдвиг наверх + opacity в 0
        */
        this.setShiftToTopAnimation(this.$title, 0, this.ANIMATION_DURATION_IN_SECONDS / 2);
        this.setOpacityAnimation(this.$title, 1, this.QUARTER_ANIMATION_DURATION);

        /* Проходим по $roundsBlockItems и задаем opacity для каждого круга */
        this.$roundsBlockItems.each((index, item) => {
            const $textContent = $(item).find(this.selectors.roundsBlockItemTextContent);
            const leftCircle = index === 0;
            const centerCircle = index === 1;
            const rightCircle = index === 2;

            this.setOpacityAnimation($textContent, 1, this.QUARTER_ANIMATION_DURATION / 2);

            if (leftCircle || rightCircle) {
                this.setOpacityAnimation(item, 1, this.ANIMATION_DURATION_IN_SECONDS);
            }

            if (centerCircle) {
                this.setOpacityAnimation(item, 1, this.ANIMATION_DURATION_IN_SECONDS / 2);
            }
        })

        /* Задаем сдвиг для контейнера с кругами наверх, чтобы контейнер был в дефолтном положении внизу */
        this.setShiftToTopAnimation(this.$roundsBlock, 0, this.QUARTER_ANIMATION_DURATION * 3);
    }

    /**
     * Задать анимацию через gsap на translateY
     * @private
     * @param element
     * @param translateY
     * @param duration
     */
    private setShiftToTopAnimation(element: JQuery<HTMLElement> | HTMLElement, translateY: number, duration: number): void {
        gsap.to(element, {
            translateY,
            duration
        });
    }

    /**
     * Задать анимацию через gsap на opacity
     * @private
     * @param element
     * @param opacity
     * @param duration
     */
    private setOpacityAnimation(element: JQuery<HTMLElement> | HTMLElement, opacity: number, duration: number): void {
        gsap.to(element, {
            opacity,
            duration
        });
    }
}
